import { render, staticRenderFns } from "./Synonyms.vue?vue&type=template&id=493004c2&scoped=true"
import script from "./Synonyms.vue?vue&type=script&lang=js"
export * from "./Synonyms.vue?vue&type=script&lang=js"
import style0 from "./Synonyms.vue?vue&type=style&index=0&id=493004c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493004c2",
  null
  
)

export default component.exports